import Excel from 'exceljs'
import R from 'ramda'

export const getWorkbook = byUser => {
  const workbook = new Excel.Workbook()

  const now = new Date()

  workbook.creator = byUser
  workbook.lastModifiedBy = byUser
  workbook.created = now
  workbook.modified = now
  workbook.lastPrinted = now

  // Set workbook dates to 1904 date system
  workbook.properties.date1904 = true

  // Force workbook calculation on load
  workbook.calcProperties.fullCalcOnLoad = true

  return workbook
}

export const toXlsxColFromGridHeaders = headers =>
  headers.map(col => {
    const colWidth = col.ident.length * 2
    return {
      header: col.display,
      key: col.ident,
      width: colWidth > 10 ? colWidth : 10,
    }
  })

export const toXlsxDataFromGridHeaders = (data, headers) => {
  const columnMap = R.zipObj(
    headers.map(col => col.ident),
    headers
  )
  return data
    .map(row => {
      if (row.modificationInfo == null) return null
      else
        return {
          ...row,
          modifier: row.modificationInfo.user,
          modifiedDate: row.modificationInfo.modDate,
        }
    })
    .map(row =>
      R.mapObjIndexed((val, key) => {
        const col = columnMap[key]
        if (col == null) return null
        if (col.type === 'num') return val && +val
        return val
      }, row)
    )
}
